import './OrderRequestHistory.scss';
import { Base_RequestHistory } from '../../Page_BaseSandbox/Base_RequestHistory/index.js';
import { ModuleFE_SandboxOrders } from '../../modules/ModuleFE_SandboxOrders/index.js';
export class OrderRequestHistory extends Base_RequestHistory {
    getHistory() {
        return ModuleFE_SandboxOrders.getHistory();
    }
    clearHistory() {
        ModuleFE_SandboxOrders.clearHistory();
    }
    convertHistoryMessageToPrint(historyMessage) {
        return {
            ...historyMessage
        }; // todo testing UID viability as index....
    }
}
//# sourceMappingURL=OrderRequestHistory.js.map